<div class="grid place-items-center tk-grid-rows h-screen tk-bg-gray-1 tk-i-background">

  <div class="mx-auto flex-1 flex-col place-items-center w-80">

    <div class="mb-3 grid place-items-center">
      <div class="i-black-marker"></div>
    </div>

    <div class="text-lg font-semibold text-center">{{'set-new-password-confirmation.header' | translate}}</div>

    <app-button label="{{'authentication-shared.goto-login' | translate}}"
                [isFullWidth]="true" innerTextClasses="my-1.5" spinnerClasses="my-3" (click)="onClick()"></app-button>
  </div>

  <am-login-footer class="mb-8 w-full"></am-login-footer>

</div>
